var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6316 44H12",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3157 47.3158C24.5773 47.3158 24.7894 47.5279 24.7894 47.7895V47.7895C24.7894 48.0511 24.5773 48.2632 24.3157 48.2632V48.2632C24.0541 48.2632 23.842 48.0511 23.842 47.7895V47.7895C23.842 47.5279 24.0541 47.3158 24.3157 47.3158",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6316 36.4211V47.7895C36.6316 49.8823 34.935 51.5789 32.8421 51.5789H15.7895C13.6966 51.5789 12 49.8823 12 47.7895V11.7895C12 9.6966 13.6966 8 15.7895 8H26.2105",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6316 30.7368C42.9102 30.7368 48 25.647 48 19.3684C48 13.0898 42.9102 8 36.6316 8C30.353 8 25.2632 13.0898 25.2632 19.3684C25.2632 25.647 30.353 30.7368 36.6316 30.7368Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.32 21.616L37.648 25H37C36.8773 25 36.7733 24.9547 36.688 24.864C36.6027 24.7733 36.56 24.656 36.56 24.512C36.56 24.4907 36.56 24.472 36.56 24.456C36.5653 24.4347 36.5707 24.4107 36.576 24.384L37.144 21.616H35.168L34.6 24.456C34.5573 24.6533 34.4747 24.7947 34.352 24.88C34.2347 24.96 34.0987 25 33.944 25H33.312L33.992 21.616H32.824C32.7013 21.616 32.6053 21.5867 32.536 21.528C32.4667 21.464 32.432 21.3573 32.432 21.208C32.432 21.1813 32.432 21.152 32.432 21.12C32.4373 21.088 32.4427 21.056 32.448 21.024L32.512 20.568H34.144L34.664 17.96H32.808L32.912 17.368C32.9387 17.2133 33 17.0987 33.096 17.024C33.192 16.9493 33.344 16.912 33.552 16.912H34.816L35.392 14.048C35.424 13.888 35.496 13.7627 35.608 13.672C35.7253 13.5813 35.864 13.536 36.024 13.536H36.664L35.992 16.912H37.968L38.64 13.536H39.272C39.4053 13.536 39.5147 13.576 39.6 13.656C39.6907 13.736 39.736 13.84 39.736 13.968C39.736 14.0107 39.7333 14.0453 39.728 14.072L39.144 16.912H40.84L40.736 17.512C40.7093 17.6667 40.6453 17.7813 40.544 17.856C40.448 17.9253 40.2987 17.96 40.096 17.96H38.992L38.472 20.568H39.904C40.032 20.568 40.1307 20.6 40.2 20.664C40.2693 20.7227 40.304 20.8293 40.304 20.984C40.304 21.0107 40.3013 21.04 40.296 21.072C40.296 21.0987 40.2933 21.128 40.288 21.16L40.216 21.616H38.32ZM35.32 20.568H37.296L37.816 17.96H35.84L35.32 20.568Z",
    fill: "#1ED760"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.02586936.svg";
export { ForwardRef as ReactComponent };